<template>
    <div class="indexList">
        <div class="list_box" @click="goDet(dataList)">
            <img class="bannerImg" :src="dataList.eventlogo" alt="">
            <div :class="type?'textBg':'textMain'">
                <p>{{dataList.title}}</p>
                <p class="flex_text"><img :src="timeIcon" alt="">{{dataList.eventtime}}</p>
                <p class="flex_text"><img :src="addrIcon" alt="">{{dataList.areaname}}</p>
            </div>
            <!-- <div class="img_under" v-show="type">
                <img :src="dataList.hostpic" alt="">
                <p>{{dataList.hostname}}</p>
            </div> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: "indexList",
        props:['type','dataList'],
        data(){
            return{
                timeIcon:require('@/common/images/hd/timeIcon.png'),
                addrIcon:require('@/common/images/hd/addrIcon.png'),
            }
        },
        methods:{
            //跳转至详情
            goDet(data){
                if(data.enrolleventsource==2){ //第三方
                    window.location.href=data.enrolllinkurl
                }else{
                    // this.$router.push({name: 'HdDetails',query:{eventid:data.eventid}})
                    const { href } = this.$router.resolve({
                        name: "HdDetails",
                        query: {
                            eventid: data.eventid
                        }
                    });
                    window.open(href, '_blank');
                }
            }
        }
    }
</script>

<style lang="scss">
    .indexList{
        .list_box{
            width: 285px;
            height: auto;
            .bannerImg{
                width: 100%;
                height: 160px;
                background: #eee;
            }
            .textBg{
                background:rgba(248,247,247,1);
            }
            .textMain{
                border:1px solid rgba(229,229,229,1);
                border-top: none;
            }
            .textMain,.textBg{
                padding: 10px 10px 12px;
                font-size: 14px;
                color: #999;
                p:first-child{
                    height: 48px;
                    font-size: 16px;
                    color: #333;
                    margin-bottom: 10px;
                    line-height: 25px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
                .flex_text{
                    display: flex;
                    align-items: center;
                    margin-top: 10px;
                    img{
                        margin-right: 5px;
                    }
                }
            }
            .img_under{
                background:rgba(248,247,247,1);
                line-height: 20px;
                border-top: 1px solid #E5E5E5;
                padding: 12px;
                display: flex;
                align-items: center;
                img{
                    width: 14px;
                    height: 14px;
                    margin-right: 5px;
                    background: #eee;
                }
            }
        }
        .list_box:hover{
            cursor: pointer;
            box-shadow:0px 0px 12px 0px rgba(0,0,0,0.2);
        }
    }
</style>